import { render, staticRenderFns } from "./contact-profile.vue?vue&type=template&id=da419bec&scoped=true&"
import script from "./contact-profile.ts?vue&type=script&lang=ts&"
export * from "./contact-profile.ts?vue&type=script&lang=ts&"
import style0 from "./contact-profile.scss?vue&type=style&index=0&id=da419bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da419bec",
  null
  
)

export default component.exports